export * from "./route.pipe";
export * from "./video.pipe";
export * from "./module/shared.pipes.module";
export * from "./values.pipe";
export * from "./meta.pipe";
export * from './kebab.pipe';
export * from "./typeform.pipe";
export * from "./sanitize.pipe";
export * from "./async-timer.pipe";
export * from "./filter.pipe";


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/index.ts